import React from "react";
import ReactDom from "react-dom";
import uniqueid from "lodash.uniqueid";

import AnchorLinkNavigation from "./AnchorLinkNavigationApp.jsx";

export default function renderAnchorLinkNavigation() {
  document
    .querySelectorAll(".js-anchor-link-navigation-mount")
    .forEach((mount, i) => {
      if (document.querySelector(".is-page-editor")) {
        return null;
      }

      const links = [...document.querySelectorAll(".js-anchor-link")].map(
        (el) => {
          const id = uniqueid("page-section-");
          // Sitecore required a placeholder so we choose "..."
          const shortTitle = el.dataset.shortTitle;
          const text =
            shortTitle && shortTitle !== "..." ? shortTitle : el.textContent;

          el.setAttribute("id", id);
          el.setAttribute("tabindex", "-1");

          return {
            id,
            href: `#${id}`,
            text,
          };
        },
      );

      if (links.length < 1) {
        mount.parentNode.classList.add("is-empty");
        return;
      }

      mount.innerHTML = ""; // getting rid of EE Placeholder text

      ReactDom.render(<AnchorLinkNavigation links={links} />, mount);
    });
}
